import React from "react";

import { cn } from "../../utils";

const Kbd = ({ className, ...props }: React.ComponentProps<"kbd">) => {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "af-pointer-events-none af-inline-flex af-h-5 af-w-fit af-min-w-5 af-select-none af-items-center af-justify-center af-gap-1 af-rounded-sm af-bg-muted af-px-1 af-font-sans af-text-xs af-font-medium af-text-muted-foreground",
        "[&_svg:not([class*='size-'])]:af-size-3",
        "[[data-slot=tooltip-content]_&]:af-bg-background/20 [[data-slot=tooltip-content]_&]:af-text-background dark:[[data-slot=tooltip-content]_&]:af-bg-background/10",
        className,
      )}
      {...props}
    />
  );
};
Kbd.displayName = "Kbd";

const KbdGroup = ({ className, ...props }: React.ComponentProps<"div">) => {
  return (
    <kbd
      data-slot="kbd-group"
      className={cn(
        "af-inline-flex af-items-center af-gap-1 af-text-xs af-text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
};

export { Kbd, KbdGroup };
